import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle, FiX } = FiIcons;

const WhoThisIsFor = () => {
  const forList = [
    "Business owners serious about growth",
    "People tired of random income",
    "Those ready to fix systems, not chase hacks"
  ];

  const notForList = [
    "Freebie collectors",
    "People expecting shortcuts",
    "Those who won't attend live"
  ];

  return (
    <section className="py-20 bg-gray-800">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold text-white text-center mb-16"
          >
            Who This Workshop Is For
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* This Is For */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="bg-gradient-to-br from-green-900/30 to-emerald-900/30 border border-green-400/50 rounded-2xl p-8"
            >
              <h3 className="text-2xl font-bold text-green-400 mb-6 text-center">
                ✅ This Is For:
              </h3>
              <ul className="space-y-4">
                {forList.map((item, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <SafeIcon icon={FiCheckCircle} className="text-green-400 text-xl mt-1 flex-shrink-0" />
                    <span className="text-white text-lg">{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* This Is NOT For */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="bg-gradient-to-br from-red-900/30 to-pink-900/30 border border-red-400/50 rounded-2xl p-8"
            >
              <h3 className="text-2xl font-bold text-red-400 mb-6 text-center">
                ❌ This Is NOT For:
              </h3>
              <ul className="space-y-4">
                {notForList.map((item, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <SafeIcon icon={FiX} className="text-red-400 text-xl mt-1 flex-shrink-0" />
                    <span className="text-white text-lg">{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoThisIsFor;